import { makeAutoObservable } from "mobx";
import type { IntegrationDescription } from "@smartsuite/automation-engine-api";

export class IntegrationStore {
  list: IntegrationDescription[] = [];
  pageSize: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setList(integrationList: IntegrationDescription[]): void {
    this.list = integrationList;
  }
}
